import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
/*eslint quote-props: ["warn", "always"]*/

import getFileExtension from '../../utils/pathUtil/getFileExtension';
var types = {
  default: '',
  loading: 'mdi mdi-loading animate-spin',
  waiting: 'mdi mdi-timer-sand-empty',
  first: 'mdi mdi-page-first',
  last: 'mdi mdi-page-last',
  back: 'mdi mdi-keyboard-backspace',
  prev: 'mdi mdi-chevron-left',
  left: 'mdi mdi-chevron-left',
  'left-double': 'ecricon-left-double',
  next: 'mdi mdi-chevron-right',
  right: 'mdi mdi-chevron-right',
  'right-double': 'ecricon-right-double',
  up: 'mdi mdi-chevron-up',
  down: 'mdi mdi-chevron-down',
  'up-filled': 'fa fa-caret-up',
  'down-filled': 'fa fa-caret-down',
  more: 'mdi mdi-dots-vertical',
  close: 'mdi mdi-close',
  cancel: 'mdi mdi-close',
  clear: 'mdi mdi-close',
  add: 'fa fa-plus',
  //'mdi mdi-plus',
  search: 'mdi mdi-magnify',
  url: 'mdi mdi-link',
  settings: 'mdi mdi-settings',
  settings2: 'mdi mdi-cogs',
  preview: 'mdi mdi-eye',
  undo: 'fa fa-undo',
  redo: 'fa fa-redo',
  save: 'ecricon-save',
  download: 'mdi mdi-download',
  'image-plus': 'mdi mdi-image-plus',
  'box-shadow': 'mdi mdi-box-shadow',
  'code-tags': 'mdi mdi-code-tags',
  eye: 'mdi mdi-eye',
  refresh: 'fa fa-sync',
  warning: 'fa fa-exclamation-circle',
  alert: 'mdi mdi-alert',
  check: 'fa fa-check',
  stop: 'fa fa-stop',
  clock: 'fa fa-clock',
  tasks: 'fa fa-th',
  signin: 'fa fa-sign-in-alt',
  paperclip: 'fa fa-paperclip',
  help: 'mdi mdi-help',
  table: 'mdi mdi-table-large',
  key: 'mdi mdi-key-variant',
  'open-new': 'mdi mdi-open-in-new'
};
var editorTypes = {
  'panel-close': 'mdi mdi-chevron-right',
  'panel-open': 'mdi mdi-menu-down',
  menu: 'mdi mdi-menu',
  'menu-down': 'mdi mdi-menu-down',
  'menu-down-rotate': 'mdi mdi-menu-down mdi-rotate-315',
  'menu-right': 'mdi mdi-menu-right',
  'menu-up': 'mdi mdi-menu-up',
  image: 'mdi mdi-image-area',
  background: 'mdi mdi-format-color-fill',
  foreground: 'mdi mdi-format-color-text',
  'font-size': 'fa fa-text-height',
  'font-family': 'mdi mdi-format-size',
  'line-height': 'mdi mdi-format-line-spacing',
  'align-left': 'mdi mdi-format-align-left',
  'align-center': 'mdi mdi-format-align-center',
  'align-right': 'mdi mdi-format-align-right',
  'align-justify': 'mdi mdi-format-align-justify',
  divider: 'mdi mdi-dots-horizontal',
  numeric: 'mdi mdi-numeric',
  responsive: 'mdi mdi-responsive',
  face: 'mdi mdi-face',
  field: 'mdi mdi-window-minimize',
  phone: 'mdi mdi-phone',
  time: 'mdi mdi-clock-outline',
  date: 'mdi mdi-calendar-range',
  address: 'mdi mdi-map-marker',
  name: 'mdi mdi-account',
  city: 'mdi mdi-city',
  'padding-all': 'mdi mdi-select-all',
  'number-format': 'fa fa-hashtag',
  'percent-format': 'fa fa-percent',
  'currency-format': 'fa fa-dollar-sign',
  'date-format': 'fa fa-calendar',
  'close-common': 'fa fa-times',
  html: 'fas fa-file-code',
  //'mdi mdi-code-tags'
  htm: 'fas fa-file-code',
  fo: 'fa fa-file-alt',
  ps: 'fas fa-file-pdf',
  doc: 'fas fa-file-word',
  docx: 'fas fa-file-word',
  relations: 'fas fa-project-diagram',
  sigma: 'mdi mdi-sigma',
  filter: 'mdi mdi-filter',
  alphabetical: 'mdi mdi-alphabetical'
};
var dataSource = {
  'data-root': 'mdi mdi-xml',
  'data-element': 'mdi mdi-xml',
  'data-attribute': 'mdi mdi-at',
  expression: 'mdi mdi-function-variant'
};
var peopleTypes = {
  visitor: 'fa fa-user-secret',
  accounts: 'ecricon-accounts',
  account: 'ecricon-accounts',
  contacts: 'ecricon-contacts',
  contact: 'ecricon-contact',
  leads: 'ecricon-lead',
  lead: 'ecricon-lead-1',
  list: 'fa fa-address-book',
  lists: 'fa fa-address-book',
  'lists-o': 'fa fa-address-book',
  'list-static': 'fa fa-address-book',
  'list-dynamic': 'ecricon-dynamic-list-1'
};
var engagementTypes = {
  persona: 'ecricon-persona-1',
  journey: 'ecricon-journey-2',
  episode: 'ecricon-episode',
  automatedprocess: 'fa fa-cogs',
  touchpoint: 'ecricon-touchpoint',
  'touchpoint-o': 'ecricon-touchpoint-outline',
  'touchpoint-2': 'ecricon-current-touchpoint',
  milestone: 'ecricon-milestone',
  click: 'ecricon-email-click',
  read: 'ecricon-email-read',
  'opt-out': 'ecricon-email-opt-out',
  Starting: 'mdi mdi-restart',
  Wait: 'ecricon-wait',
  RunWorkflow: 'ecricon-workflow',
  RunCommunication: 'ecricon-communication-1',
  TouchpointCompleted: 'ecricon-touchpoint',
  CreateTask: 'fa fa-th'
};
var projectTypes = {
  project: 'ecricon-project',
  communication: 'ecricon-communication-1',
  analyticsdashboard: 'fa fa-chart-line',
  batch: 'ecricon-project',
  ondemand: 'ecricon-project',
  interactive: 'ecricon-form',
  contract: 'ecricon-contract',
  contractTemplate: 'ecricon-contract-template'
};
var promotionTypes = {
  'promotion-ad': 'ecricon-ads',
  promotion: ' ecricon-campaigns2',
  'promotion-ad-placement': 'mdi mdi-pin'
};
var repositoryTypes = {
  'new-folder': 'mdi mdi-folder-plus',
  upload: 'mdi mdi-upload',
  file: 'mdi mdi-file',
  'file-outline': 'far fa-file',
  files: 'fa fa-copy',
  'files-outline': 'far fa-copy',
  folder: 'mdi mdi-folder',
  workspace: 'fa fa-briefcase',
  archive: 'fa fa-archive',
  repository: 'mdi mdi-file-tree',
  ':recent': 'mdi mdi-history',
  ':favorites': 'mdi mdi-star',
  epr: 'fa fa-file-alt',
  xfd: 'fa fa-file-alt',
  epb: 'fa fa-puzzle-piece',
  epj: 'ecricon-project',
  ect: 'fa fa-file-signature',
  css: 'fab fa-css3',
  ehtml: 'fa fa-envelope',
  edx: 'fa fa-database',
  edm: 'fa fa-database',
  imdb: 'fa fa-database',
  xml: 'ecricon-xml',
  efd: 'ecricon-form',
  wk4: 'ecricon-workflow',
  bid: 'fa fa-chart-line',
  ead: 'fa fa-chart-line',
  png: 'fa fa-file-image',
  jpg: 'fa fa-file-image',
  jpeg: 'fa fa-file-image',
  pdf: 'fas fa-file-pdf',
  emailbody: 'ecricon-mail',
  email: 'ecricon-mail',
  html: 'fas fa-file-code',
  htm: 'fas fa-file-code',
  fo: 'fa fa-file-alt',
  ps: 'fas fa-file-pdf',
  doc: 'fas fa-file-word',
  docx: 'fas fa-file-word',
  eld: peopleTypes['list']
};
var organizationTypes = {
  analytics: 'fa fa-chart-line',
  developer: 'fa fa-laptop'
};
var commonIcons = {
  bold: 'fa fa-bold',
  italic: 'fa fa-italic',
  pie: 'ecricon-pie',
  gauge: 'ecricon-gauge',
  erase: 'fa fa-eraser',
  table: 'ecricon-table',
  'nav-back': 'fa fa-level-up-alt fa-rotate-270',
  text: 'fa fa-file-alt',
  style: 'fa fa-pencil-alt',
  data: 'fa fa-database',
  delete: 'fa fa-trash-alt',
  remove: 'mdi mdi-close-circle',
  'ellipsis-h': 'fa fa-ellipsis-h',
  desktop: 'fa fa-desktop',
  tablet: 'fa fa-tablet',
  mobile: 'fa fa-mobile',
  'single-element': 'fa fa-minus',
  'split-element': 'ecricon-glyphicon-duplicate',
  'multiple-element': 'fa fa-bars',
  field: 'fa fa-circle',
  locked: 'fa fa-lock',
  unlocked: 'fa fa-unlock',
  width: 'ecricon-width-1',
  height: 'ecricon-height-1',
  detail: 'fa fa-align-justify',
  thumbnail: 'fa fa-th-large',
  sortable: 'fa fa-angle-down',
  sortAsc: 'fa fa-long-arrow-alt-up',
  sortDesc: 'fa fa-long-arrow-alt-down',
  share: 'fa fa-share-alt',
  'format-data': 'fa fa-paint-brush',
  home: 'ecricon-home',
  user: 'fa fa-user',
  'user-plus': 'ecricon-user-plus',
  'user-minus': 'ecricon-user-minus',
  'user-edit': 'ecricon-user-edit',
  group: 'fa fa-users',
  category: 'fa fa-th-large',
  dependencies: 'ecricon-dependencies',
  info: 'fas fa-info-circle'
};
var ecricon = {
  mail: 'ecricon-mail',
  button: 'ecricon-button',
  'column-chart': 'ecricon-column',
  'column-left': 'ecricon-left',
  'column-right': 'ecricon-right',
  'two-columns': 'ecricon-two-columns',
  'three-columns': 'ecricon-three-columns',
  'two-rows': 'ecricon-three-rows',
  'three-rows': 'ecricon-three-rows',
  components: 'ecricon-mail',
  // clear: 'ecricon-clear', missing icon
  'light-bulb': 'ecricon-light-bulb',
  'line-chart': 'ecricon-line',
  page: 'ecricon-page-1',
  'page-batch': 'ecricon-page-batch',
  'bar-chart': 'ecricon-bar',
  brush: 'ecricon-brush',
  'area-chart': 'ecricon-area',
  heart: 'ecricon-heart',
  'thumbs-up': 'ecricon-thumbs-up',
  'rest-trigger': 'ecricon-rest-trigger'
};
var jobs = {
  FinishedOK: 'fa fa-check-circle',
  //'fa fa-check',
  Processing: 'ecricon-progress',
  WaitingOnTask: 'ecricon-scheduled',
  WaitingOnItem: 'ecricon-scheduled',
  Triggered: 'ecricon-trigger',
  FinishedWithErrors: 'fa fa-exclamation-triangle',
  WaitingForInput: 'ecricon-progress',
  WaitingForSignature: 'ecricon-progress'
};
var microservices = {
  profile: 'mdi mdi-server',
  microservice: 'fa fa-puzzle-piece',
  organization: 'mdi mdi-domain',
  folio: 'fa fa-lightbulb'
};
export function getRepositoryIcon(path) {
  var icon = repositoryTypes['repository'];

  if (path === null) {
    icon = repositoryTypes['file'];
  } else if (path === '') {
    icon = repositoryTypes['repository'];
  } else if (path[0] === ':') {
    //view
    icon = repositoryTypes[path];
  } else if (path.indexOf('.') > -1) {
    var ext = getFileExtension(path).toLowerCase();
    icon = repositoryTypes[ext] || repositoryTypes['file'];
  } else if (path.split('/').length > 1 || path.split('\\').length > 1) {
    icon = repositoryTypes['folder'];
  } else {
    icon = repositoryTypes['workspace'];
  }

  return icon;
}

var ICON_TYPES = _objectSpread({}, types, editorTypes, repositoryTypes, dataSource, peopleTypes, engagementTypes, projectTypes, promotionTypes, organizationTypes, commonIcons, ecricon, jobs, microservices);

export default ICON_TYPES;